import { Instance } from 'mobx-state-tree';
import { RouteReversingDtoModelBase } from './RouteReversingDtoModel.base';

/* The TypeScript type of an instance of RouteReversingDtoModel */
export interface RouteReversingDtoModelType extends Instance<typeof RouteReversingDtoModel.Type> {}

/* A graphql query fragment builders for RouteReversingDtoModel */
export { selectFromRouteReversingDto, routeReversingDtoModelPrimitives, RouteReversingDtoModelSelector } from './RouteReversingDtoModel.base';

/**
 * RouteReversingDtoModel
 *
 * Route reversing event
 */
export const RouteReversingDtoModel = RouteReversingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
